import { FC } from "react";

interface Props {
  errors?: string | string[];
}

const ErrorMessageComponent: FC<Props> = ({ errors }) =>
  !errors ? (
    <></>
  ) : typeof errors === "string" ? (
    <div className="text-red-500 pl-2 pt-1">{errors}</div>
  ) : (
    <>
      {errors.map((error) => (
        <div key={error} className="text-red-500 pl-2 pt-1">
          {error}
        </div>
      ))}
    </>
  );

export default ErrorMessageComponent;
